window.deployerAdapter = window.deployerAdapter || {};

const deployerEvents = {
  variantChange: 'variant:change'
}

/**
 * @param {Event} eventName 
 * @param {Object} data 
 */
function deployerDispatchNewEvent(eventName, data) {
  document.dispatchEvent(new CustomEvent(eventName, { detail: data }));
}

class DeployerElement extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.setupVariables();
      this.setupEvents();
    }

    setupVariables() {
      throw new Error('setupVariables is not implemented');
    }

    setupEvents() {
      throw new Error('setupEvents is not implemented');
    }
    
  }
  
window.customElements.define('deployer-element', DeployerElement);
